import { useState, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import context from "lib/stores/context";
import { useSnapshot } from "valtio";
import { ReactComponent as IconSearch } from "components/icons/search.svg";

const SidebarSearch = () => {
  const ref = useRef();
  const { isCollapsed, searchQuery, activeTabWorldwide, activeTabCountries, activeTabRegions, activeView } = useSnapshot(context);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (activeTabWorldwide === 0 || activeTabRegions === 0) {
      setHidden(false);
    } else {
      setHidden(true);
    }
  }, [activeTabWorldwide, activeTabRegions]);

  useEffect(() => {
    context.searchQuery = "";
  }, [activeView, activeTabWorldwide, activeTabCountries, activeTabRegions]);

  // const onFocus = () => {
  //   if (!ref.current) return;
  //   ref.current.scrollIntoView({ behavior: "smooth" });
  // };

  if (
    (activeView === "worldwide" && activeTabWorldwide === 0) ||
    (activeView === "worldwide" && activeTabWorldwide === 1) ||
    (activeView === "region" && activeTabRegions === 0)
  ) {
    if (window.innerWidth >= 1023) {
      return (
        <div
          id="sidebar-search"
          className={classNames(
            styles["sidebar-search-wrapper"],
            `z-[20] transition sticky top-0 duration-500 ease-out ${hidden ? "opacity-0 -translate-x-5" : ""}`
          )}
        >
          <div className={styles["sidebar-search-root"]}>
            <input
              className={styles.input}
              onChange={e => (context.searchQuery = e.target.value)}
              placeholder="Search..."
              value={searchQuery}
            />
            <span>
              <IconSearch />
            </span>
          </div>
        </div>
      );
    }
    if (window.innerWidth <= 1023) {
      return (
        <>
          <div
            id="sidebar-search"
            className={classNames(
              styles["sidebar-search-wrapper"],
              `z-[20] transition duration-500 sticky top-0 ${hidden ? "opacity-0 -translate-x-5" : ""}`
            )}
          >
            <div className={styles["sidebar-search-root"]}>
              <input
                ref={ref}
                // onFocus={onFocus}
                className={styles.input}
                onChange={e => (context.searchQuery = e.target.value)}
                placeholder="Search..."
                value={searchQuery}
              />
              <span>
                <IconSearch />
              </span>
            </div>
          </div>
          {/* <div className="pb-4" /> */}
        </>
      );
    }
  }
};

export default SidebarSearch;
